import { ACTIVIDAD_PILL, textoActividad, type NivelActividad } from "@/lib/actividad";

// Pill compacta "hace N d" con color de semáforo. Qué significa cada color lo
// explica la Ayuda de cada lista de casos (`components/ayuda/vistas/fichasCaso`),
// no un tooltip. Si el caso no trae datos (cerrados), no renderiza nada.
export default function ActividadPill({
  dias,
  nivel,
}: {
  dias: number | null | undefined;
  nivel: string | null | undefined;
}) {
  if (dias == null || !nivel) return null;
  const n = (nivel in ACTIVIDAD_PILL ? nivel : "ok") as NivelActividad;
  return (
    <span
      className={`inline-flex items-center text-[10px] px-1.5 py-0.5 rounded border whitespace-nowrap ${ACTIVIDAD_PILL[n]}`}
    >
      {textoActividad(dias)}
    </span>
  );
}
